'use strict';

import React, { Component } from 'react';

import Form from "react-jsonschema-form";
import Select from 'react-select';
import PopUp from '../../../commonModules/interface/PopUp';
import InputText, { TextArea ,InputSelect} from '../../../commonModules/interface/form-input-inline';
import { Button } from '@material-ui/core';

class PlanInstallationJsonForm extends Component{

    state = {
        msg: this.props.msg,
        errormsg:"",
        jsonSchema: {},
        uiSchema: {},
        schemaID: "",
        selectedInstallator: "",
        selectedInstallatorDisplay: {value: "", label:""},
        commission: "",
        comment: "",
        commentTech: "",
        // transport: "",
        km: "",
        clientForm: false,
    }
     componentDidMount = async () => {

        //Get Schema to get Schema for Plan Installation 
        try {
            const response = await fetch('/schema/default?type=HasPayed&boxAssoId=' + this.props.user, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                credentials: 'same-origin',                    
            });            
            const resp = await response.json();
            console.log(resp);
            let jsonrep = {};
            let uirep = {};

            try {
                uirep = JSON.parse(resp.uiSchema);
            } catch(e) {
                uirep = resp.uiSchema ;
            }
            try{
                jsonrep = JSON.parse(resp.jsonSchema);
            } catch(e) {
                jsonrep = resp.jsonSchema ;
            }

            this.setState({jsonSchema: jsonrep,uiSchema: uirep, schemaID: resp.schemaID});
        } catch (err) {
            console.log("[ERROR], getting prospect data",err)
        }
    }

    handleChange = (e) => {
        const { value, name } = e.target
        this.setState({
            [name]: value,
        })
    }
    onSubmit = async (form) => {
        console.log("[INFO] Data submitted: " + form.formData);

        try {
            const response = await fetch('/user/prospect/update/toInstallation', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                credentials: 'same-origin',                    
                body: JSON.stringify({
                    jsonschemaID: this.state.schemaID,
                    formData: form.formData,
                    boxAssoId: this.props.user,
                    installatorID: this.state.selectedInstallator,
                    commission: parseFloat(this.state.commission),
                    comment: this.state.comment,
                    commentTech: this.state.commentTech,
                    changeInstallateur: this.props.changeInstallateur,
                    // transport: parseFloat(this.state.transport),
                    km: parseFloat(this.state.km),
                })
            });
            const resp = await response.json();
            console.log(resp);
            if (resp.msg != "OK" ){
                this.setState({errormsg: resp.err.toString()});                    
                return;
            }
            this.props.onValidation();
        } catch (err) {
            console.log(err);
            this.setState({
                errormsg: 'Error : ' + err.error
            });
        }
    }
    back = async (e) => {
        e.preventDefault();
        this.setState({clientForm: false});
    }
    next = async (e) => {
        e.preventDefault();
        if (this.state.selectedInstallator !== ""){
            this.setState({clientForm: true});
            return;
        }
        console.log('[INFO], Must choose an installator : ',this.state.selectedInstallator);
    }

    render() {
        console.log("[DEBUG], Validation, Plan Installlation, ",this.props.installator);
       
        return (
            <PopUp
                close={this.state.clientForm ? this.back : this.props.onCancelation}
                title={this.props.name}
                submitAction={this.state.clientForm ? this.onSubmit : this.next}
                submitTitle={this.state.clientForm ? "Valider": "Suivant"}
            >
                    { this.state.clientForm ? 
                    <p>
                        <Form
                            className="bootgrid-header container-fluid"
                            schema={this.state.jsonSchema}
                            uiSchema={this.state.uiSchema} 
                            // onSubmit={this.onSubmit}
                        />
                    </p>
                    :
                    <div>
                        
                        <div className="form-group">
                            <InputSelect 
                                value={this.state.selectedInstallator} 
                                onChange={(option, value) => this.setState({ 
                                    selectedInstallator: value,
                                    selectedInstallatorDisplay: option 
                                }) } 
                                label="Choisissez le technicien qui fera l'installation *"
                                options={this.props.installator.map(item => (
                                    { value:item.idobj,  label:item.id } 
                                ))}
                            />
                        </div>
                        <div className="form-group">
                            <InputText label="Nombre Km Prévu" type="number" onChange={this.handleChange} value={this.state.km} name="km" />
                        </div>
                        <div className="form-group">
                            <InputText label="Commission Installation" required type="number" onChange={this.handleChange} value={this.state.commission} name="commission" />
                        </div>
                        <div className="form-group">
                            <TextArea 
                                label="Remarques" 
                                required
                                onChange={this.handleChange} 
                                value={this.state.comment} 
                                name="comment" 
                                rows="4"
                            />
                        </div>                        

                    </div>
                    }
                    
                    <i style={{color: "red"}}><p>{this.state.errormsg}</p></i>
                    {/* <div className="text-right">
                        { this.state.clientForm ? 
                            <Button className="btn btn-cancel" color="secondary" onClick={this.back}>Précédent</Button>
                        : 
                            <Button color="secondary" variant="contained" className="btn btn-primary" onClick={this.next}>Suivant</Button>
                        }
                        <Button className="btn btn-cancel" onClick={this.cancel}>Annuler</Button>
                    </div> */}
            </PopUp>
        );
    }
};
export default PlanInstallationJsonForm